import { Map as ImmutableMap, List, Record } from 'immutable';
import Status from '../../common-message-format/records/Status';
import { buildSendersFromLegacySender } from '../../senders/operators/buildSendersFromLegacySender';
import { CUSTOMER_AGENT_FEEDBACK_MESSAGE } from '../constants/messageTypes';
class CustomerAgentFeedbackMessage extends Record({
  '@type': CUSTOMER_AGENT_FEEDBACK_MESSAGE,
  channelInstanceId: null,
  clientType: null,
  direction: null,
  feedbackType: null,
  genericChannelId: null,
  hiddenBy: null,
  id: null,
  messageId: null,
  sender: ImmutableMap(),
  senders: List(),
  status: Status(),
  timestamp: null
}, 'CustomerAgentFeedbackMessage') {
  constructor(props) {
    const superProps = props && buildSendersFromLegacySender(props);
    super(superProps);
  }
}
export default CustomerAgentFeedbackMessage;